var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6855 21.15C6.99724 28.1813 3.06379 36.4652 1.21011 45.3172C-0.64357 54.1692 -0.364264 63.3353 2.02495 72.058C4.41417 80.7808 8.8447 88.8098 14.9505 95.4817C21.0563 102.154 28.662 107.277 37.1393 110.428C45.6166 113.579 54.722 114.668 63.7033 113.604C72.6846 112.541 81.2838 109.355 88.7906 104.311C96.2973 99.2672 102.496 92.5092 106.875 84.5957C111.253 76.6822 113.686 67.8405 113.972 58.8009L112.032 58.7396C111.756 67.4714 109.406 76.0121 105.176 83.6561C100.947 91.3001 94.9593 97.828 87.7081 102.7C80.457 107.573 72.1505 110.65 63.475 111.677C54.7996 112.704 46.0042 111.653 37.8155 108.609C29.6269 105.565 22.2801 100.616 16.3822 94.1714C10.4844 87.7267 6.20468 79.971 3.89682 71.5453C1.58895 63.1196 1.31916 54.2656 3.10972 45.715C4.90028 37.1644 8.69981 29.1625 14.1943 22.3707L12.6855 21.15Z",
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 21.5,
    r: 3.5,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI1);
export default __webpack_public_path__ + "static/media/i1.45517648564982f8fcab87242dd7db5f.svg";
export { ForwardRef as ReactComponent };